import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import * as fromFilters from './filters/reducer/filters.reducer';
import * as fromOrderDetails from './order-details/reducers/order-details.reducer';
import * as fromOrders from './orders/orders.reducer';
import { orderBookFeatureKey } from './prefix';

export interface OrderBookState {
  [fromOrders.ordersFeatureKey]: fromOrders.OrdersState;
  [fromFilters.filtersFeatureKey]: fromFilters.FiltersState;
  [fromOrderDetails.orderDetailsFeatureKey]: fromOrderDetails.OrderDetailsState;
}

export interface OrderBookRootState {
  [orderBookFeatureKey]: OrderBookState;
}

export const initialState: OrderBookState = {
  [fromOrders.ordersFeatureKey]: fromOrders.initialState,
  [fromFilters.filtersFeatureKey]: fromFilters.initialState,
  [fromOrderDetails.orderDetailsFeatureKey]: fromOrderDetails.initialState,
};

export function reducers(state: OrderBookState | undefined, action: Action) {
  return combineReducers({
    [fromOrders.ordersFeatureKey]: fromOrders.reducer,
    [fromFilters.filtersFeatureKey]: fromFilters.reducer,
    [fromOrderDetails.orderDetailsFeatureKey]: fromOrderDetails.reducer,
  })(state, action);
}

export const selectOrderBookState =
  createFeatureSelector<OrderBookState>(orderBookFeatureKey);
